<template>
  <div>
    <!-- <infos
      :type="7"
      v-if="firstInfo"
      @nextButton="nextInfo"
      @goBack="back"
    ></infos> -->
    
    <div class="panel-group last-panel" v-if="!firstInfo">
      <div class="panel">
        <div class="col-md-12">
          <p>
            Agora, precisamos que você preencha o Termo de Imagem de seu(s) acompanhante(s) qualificado(s) e extra(s), se houver.<br/>
Todos os acompanhantes deverm assinar esse termo. Para isto, siga os passos abaixo.<br/>
Os responsáveis técnicos não precisam assinar esse termo, apenas os acompanhantes, se houver.

          </p>
          <hr />
          <p>
            1. Faça o download do arquivo (termo: adulto e/ou menor de 18 anos) clicando
            em "download"
          </p>
          <p>2. Preencha o arquivo com os dados de cada acompanhante</p>
          <p>3. Imprima</p>
          <p>
            4. Peça para o(s) acompanhante(s) assinar(em) - no caso de menor de 18 anos,
            o responsável que deve assinar;
          </p>
          <p>
            5. Digitalize o termo e envie para ptcpiic.brasil@prudential.com até dia 31/03/2025.
          </p>
          <a
            href="../../assets/resources/Termo_de_Uso_de_Imagem_para_MAIORES.pdf"
            download
            class="fancy download-button"
          >
            <i class="fa fa-file-pdf-o"></i> Download do termo de direito de
            imagem para
            <strong>adultos.</strong>
          </a>
          <a
            href="../../assets/resources/Termo_de_Uso_de_Imagem_para_MENORES.pdf"
            download
            class="fancy download-button"
          >
            <i class="fa fa-file-pdf-o"></i> Download do termo de direito de
            imagem para
            <strong>menores de 18 anos.</strong>
          </a>
        </div>
      </div>
    </div>
    <div class="action-buttons" v-if="!firstInfo">
      <custom-button
        @clicked="
          firstInfo = false;
          back();
        "
        myText="Voltar"
        icon="chevron-left"
        pos="left"
      ></custom-button>
      <custom-button
        myText="Próximo"
        icon="chevron-right"
        pos="right"
        @clicked="finish"
      ></custom-button>
    </div>
  </div>
</template>

<script>
import { mixin } from "../../mixin.js";
import Infos from "../Infos.vue";
import CustomButtom from "../shared/CustomButton.vue";
import Modal from "../shared/Modal.vue";
export default {
  components: {
    Infos,
    "custom-button": CustomButtom,
    modal: Modal,
  },
  mixins: [mixin],
  data: function () {
    return {
      firstInfo: false,
      informationModal: false,
    };
  },
  computed: {
    link: function () {
      return window.location.origin;
    },
  },
  methods: {
    nextInfo: function () {
    },
    back: function () {
      this.$emit("changeTab", "Voo");
      this.scrollOnTop();
    },
    finish: function () {
      // this.informationModal = true;
      this.$emit("changeTab", "Adicionais");
      this.scrollOnTop();
    },
    closeModal: function () {
      // this.informationModal = false;
      // this.$emit("changeTab", "Adicionais");
      // this.scrollOnTop();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../src/assets/css/variables";

.last-panel a {
  position: relative;
  display: block;
  text-align: center; //border: 3px solid rgba($brand-color, .1);
  // border: 3px solid $brand-color;
  margin-top: 1.5em;
  padding: 1em;

  i {
    margin-right: 1em;
  }
}

.download-button {
  border: 3px solid $brand-color;
}
</style>


// WEBPACK FOOTER //
// src/components/tabs/Terms.vue